
import { BookYearService } from "@/services/book-year-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

enum ExtraAction {
	CREATE_NEW_BOOKYEAR,
	CREATE_OLD_BOOKYEAR,
	DELETE_NEWEST_BOOK_YEAR
}

export default Vue.extend({
	data() {
		return {
			startMonth: DossierConfigService.getGeneralConfig().BookYearStartMonth,
			startDate: DossierConfigService.getGeneralConfig().BookYearStartDate,
			canDeleteNewestBookYear: false
		};
	},
	computed: {
		months(): ISelectItem<number>[] {
			let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
			return months.map(m => {
				return {
					text: this.$t("common.months." + m).toString(),
					value: m - 1
				} as ISelectItem<number>;
			});
		},
		dates():ISelectItem<number>[] {
			let dates:ISelectItem<number>[] = [];
			let dayCount = 30;
			if (this.startMonth == 1) {
				dayCount = 28;
			}
			if ([0,2,4,6,7,9,11].indexOf(this.startMonth) != -1) {
				dayCount = 31;
			}
			for (let i = 1; i <= dayCount; i++) {
				dates.push({
					text: `${i}`,
					value: i
				});
			}
			return dates;
		},
		actionsList():ISelectItem<ExtraAction>[]{
			let result:ISelectItem<ExtraAction>[] = [
				{
					text: this.$ct("create-new-bookyear"),
					value: ExtraAction.CREATE_NEW_BOOKYEAR
				},
				{
					text: this.$ct("create-old-bookyear"),
					value: ExtraAction.CREATE_OLD_BOOKYEAR
				}
			];

			if (this.canDeleteNewestBookYear) {
				let newestBookYear = BookYearService.getNewestBookYear();
				result.push({
					text: this.$ct("delete-bookyear", {bookyear: newestBookYear.Year}),
					value: ExtraAction.DELETE_NEWEST_BOOK_YEAR
				});
			}

			return result;
		}
	},
	watch: {
		startMonth: {
			handler(){
				let highestDate = this.dates[this.dates.length - 1].value;
				if (this.startDate > highestDate) {
					this.startDate = highestDate;
				}
			}
		}
	},
	methods: {
		async saveBookyearConfig() {
			let conf = DossierConfigService.getGeneralConfig();
			conf.BookYearStartMonth = this.startMonth;
			conf.BookYearStartDate = this.startDate;
			await DossierConfigService.saveGeneralConfig(conf);
			this.$wf.notify(this.$ct("saved"), "success", 3000, "check");
		},
		createNew(){
			BookYearService.manualCreateNewBookyear = true;
		},
		async createOldBookYear(){
			let year = BookYearService.oldestBookYear.Year - 1;
			let confirmMessage = this.$ct("are-you-sure-you-want-to-create-bookyear-this-action-cant-be-undone", {year});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(confirmMessage).show();
			if (!confirm) return;
			let createdYear = await BookYearService.createOlderBookYear(year);
			this.$wf.notify(this.$ct("bookyear-created", {year: createdYear.Year}), "success", 3000, "check");
		},
		triggerAction(action:ExtraAction){
			if (action == ExtraAction.CREATE_NEW_BOOKYEAR){
				this.createNew();
			} else if (action == ExtraAction.CREATE_OLD_BOOKYEAR){
				this.createOldBookYear();
			} else if (action == ExtraAction.DELETE_NEWEST_BOOK_YEAR) {
				this.deleteNewestBookYear();
			}
		},
		async deleteNewestBookYear():Promise<void>{
			let bookyear = BookYearService.getNewestBookYear();
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("are-you-sure-you-want-to-delete-book-year", {bookyear: bookyear.Year})).show();
			if (!confirm) return;
			await BookYearService.deleteBookYear(bookyear);
			this.$wf.notify(this.$ct("book-year-deleted"), "success", 3000, "check");
			await BookYearService.fetchBookYears();
			this.checkCanDeleteNewestBookYear();
			if (BookYearService.bookYears.findIndex(b=>b.Year == BookYearService.selectedBookYear) == -1){
				BookYearService.selectBookYear(BookYearService.getNewestBookYear());
			}
		},
		async checkCanDeleteNewestBookYear(){
			let newestBookYear = BookYearService.getNewestBookYear();
			this.canDeleteNewestBookYear = await BookYearService.canDeleteBookYear(newestBookYear);
		}
	},
	async created(){
		await this.checkCanDeleteNewestBookYear();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
